import PropTypes from 'prop-types'

import {NOTIFICATION_TYPES} from './config.js'
import {Notification} from './notification.js'

const NotificationsAdsComparator = ({type, comparatorSelectedAds, extendedTrackingData, onClose, className}) => {
  if (!type) return null
  return (
    <Notification
      type={type}
      comparatorSelectedAds={comparatorSelectedAds}
      extendedTrackingData={extendedTrackingData}
      onClose={onClose}
      className={className}
    />
  )
}

NotificationsAdsComparator.displayName = 'NotificationsAdsComparator'

NotificationsAdsComparator.propTypes = {
  type: PropTypes.oneOf(Object.values(NOTIFICATION_TYPES)),
  onClose: PropTypes.func,
  comparatorSelectedAds: PropTypes.array,
  extendedTrackingData: PropTypes.object,
  className: PropTypes.string
}

export {NOTIFICATION_TYPES}
export default NotificationsAdsComparator
